import { Connection } from '../../app/DTOs/Connection.component';
import { ItinerarioObject } from '../../app/DTOs/ItinerarioObject.component';

export class LineObject {
    private id: string;
    private name: string;
    private surname: string;
    private number: number;
    private color: string;
    private itinerarios: ItinerarioObject[] = [];

    constructor( id: string, name: string, surname: string, number: number, color: string, itinerarios: ItinerarioObject[] ) {
        this.id = id;
        this.name = name;
        this.surname = surname;
        this.number = number;
        this.color = color;
        this.itinerarios  = itinerarios;
    }

    public setId (id: string) { this.id = id; }
    public getId () { return this.id; }
    
    public setName (name: string) { this.name = name; }
    public getName () { return this.name; }
    
    public setSurname (surname: string) { this.surname = surname; }
    public getSurname () { return this.surname; }
    
    public setNumber (number: number) { this.number = number; }
    public getNumber () { return this.number; }
    
    public setColor (color: string) { this.color = color; }
    public getColor () { return this.color; }
    
    public setItinerarios (itinerarios: ItinerarioObject[]) { this.itinerarios = itinerarios; }
    public getItinerarios () { return this.itinerarios; }
    
    public searchForItinerario (idItinerario: string, id_line : string) {
        var itinerario: ItinerarioObject[] = this.getItinerarios();        
        for (var i = 0; i < itinerario.length; i++) {
            if (idItinerario == itinerario[i].getId() && id_line == itinerario[i].getId_linea()) {
                return itinerario[i];
            }   
        }
    }
    
    public searchForId (idSearched: string) {
        if (idSearched == this.id) {
            return true;
        } else {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/DTOs/LineObject.component.ts